import fr from './fr.json'
import en from './en.json'
import it from './it.json'
import es from './es.json'
import pt from './pt.json'
import de from './de.json'

export default {
  fr,
  en,
  it,
  es,
  pt,
  de
}